import React from 'react'
import { useState } from "react";
import { customAlert, notify } from './notify';
import { getFileUrl } from '../services/s3-service';
import { Box, ButtonBase, CircularProgress, IconButton, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { Edit } from '@mui/icons-material';
import fileIconSVG from "../assets/svg/fileIcon.svg"

function FileViewLabel({ label, minWidth, maxWidth, bgcolor, icon, fontSize, fileKey, fileKeys, value, onEdit, contWidth }) {

    const [loading, setLoading] = useState(false)
    const [menuAnchor, setMenuAnchor] = useState(null);

    // Multi-file list takes priority; fall back to the legacy single key.
    const allKeys = fileKeys?.length ? fileKeys : (fileKey ? [fileKey] : []);

    async function openFile(key) {
        setLoading(true);
        try {
            const fileUrl = await getFileUrl({ fileKey: key });
            window.open(fileUrl, "_blank")
        } catch (err) {
            // console.log(err);
            customAlert(err);
        }
        setLoading(false);
    }

    async function handleClick(e) {
        if (allKeys.length === 0) {
            notify("info", "No File Found")
            return
        }
        if (allKeys.length === 1) {
            await openFile(allKeys[0]);
            return;
        }
        setMenuAnchor(e.currentTarget);
    }

    async function handleMenuItemClick(key) {
        setMenuAnchor(null);
        await openFile(key);
    }

    return (
        <Stack minWidth={minWidth} maxWidth={maxWidth} bgcolor={bgcolor}>
            <Stack direction={"row"} gap={0.3} alignItems={"center"} mb={0.4}>
                <Typography sx={{ fontSize: 14, fontWeight: "550" }}>{label}</Typography>
                {onEdit && <IconButton onClick={onEdit}><Edit sx={{ fontSize: 18, color: "primary.main" }} /></IconButton>}
            </Stack>
            <ButtonBase component="div" onClick={handleClick} sx={{ backgroundColor: "rgba(249, 248, 254, 1)", height: 35, width: contWidth ? contWidth : 200, borderRadius: 1, justifyContent: "start" }}>
                <Stack direction={"row"} alignItems={"center"} >
                    <Box component={"img"} src={icon || fileIconSVG} alt={icon} mx={1.3} sx={{ height: 18 }} />
                    <Typography sx={{ fontSize: fontSize || 14.5, fontWeight: "600", color: "rgba(5, 49, 227, 1)", mr: 2 }}>
                        {value ? value : label}{allKeys.length > 1 ? ` (${allKeys.length})` : ""}
                    </Typography>
                    {loading && <CircularProgress size={20} />}
                </Stack>
            </ButtonBase>
            <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)}>
                {allKeys.map((k, i) =>
                    <MenuItem key={k} sx={{ fontSize: 14, fontWeight: "600", color: "rgba(5, 49, 227, 1)", minWidth: 180 }} onClick={() => handleMenuItemClick(k)}>
                        <Box component={"img"} src={icon || fileIconSVG} alt={""} mr={1.3} sx={{ height: 16 }} />
                        {label} {i + 1}
                    </MenuItem>)}
            </Menu>
        </Stack>
    )
}

export default FileViewLabel
